import "./SingleCorsoTemplate.module.css"
import HeaderNavigazione from "@/reusable_sections/Header"
import SingleCorsoTemplateSection from "./sections/SingleCorsoTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleCorsoTemplatePage() {

  return (
    <div>
      <HeaderNavigazione />
      <SingleCorsoTemplateSection />
      <Footer />
    </div>
  )
}
